import { Typography } from '@mui/material';

export function LogoTitle() {
    return (
        <>
            <Typography variant="subtitle2" sx={{ mt: 0.5, ml: 1, color: 'text.primary' }}>
                one
            </Typography>
            <Typography variant="subtitle2" sx={{ mt: 0.5, color: 'text.secondary' }}>
                VIEW
            </Typography>
        </>
    )
}
